import type { manage as en } from '@/i18n/locales/en/manage';
import type { Translation } from '@/i18n/types';

export const manage: Translation<typeof en> = {
  backToApp: 'Επιστροφή στην εφαρμογή',
  sections: {
    companies: {
      label: 'Εταιρείες',
      items: {
        companies: 'Εταιρείες',
        pilots: 'Πιλοτικά',
      },
    },
    people: {
      label: 'Άτομα',
      items: {
        users: 'Όλοι οι χρήστες',
        linkIdentities: 'Σύνδεση ταυτοτήτων',
        admins: 'Διαχειριστές',
      },
    },
    audit: {
      label: 'Έλεγχος',
      items: {
        audit: 'Αρχείο ελέγχου',
      },
    },
    subscriptions: {
      label: 'Συνδρομές',
      items: {
        config: 'Provider configuration',
        products: 'Προϊόντα & πάροχοι',
        userLedger: 'Καθολικό χρηστών',
      },
    },
    system: {
      label: 'Σύστημα',
      items: {
        statistics: 'Κατάσταση στατιστικών & ανακατασκευή',
        requests: 'Αιτήματα API',
      },
    },
    support: {
      label: 'Υποστήριξη',
      items: {
        tickets: 'Αιτήματα',
      },
    },
    overview: {
      label: 'Επισκόπηση',
      items: {
        overview: 'KPI',
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'Κατάσταση στατιστικών & ανακατασκευή',
      note: 'Η κατάσταση στατιστικών και τα στοιχεία ελέγχου ανακατασκευής αποτελούν ξεχωριστό σχέδιο — αυτή η καταχώριση μενού κρατά τη θέση, η οθόνη δεν έχει κατασκευαστεί στη φάση 1.',
    },
  },
  usersAll: {
    title: 'Όλοι οι χρήστες',
    linkIdentities: 'Σύνδεση ταυτοτήτων',
    empty: 'Δεν υπάρχουν ακόμη ταυτότητες.',
    name: 'Όνομα',
    email: 'Email',
    language: 'Γλώσσα',
    login: 'Σύνδεση',
    yes: 'ναι',
    no: 'όχι',
    view: 'Προβολή',
    rowsLabel: 'τους χρήστες',
  },
  linkIdentities: {
    title: 'Σύνδεση διπλών ταυτοτήτων',
    lead: 'Το ψευδώνυμο εξακολουθεί να υπάρχει, αλλά δείχνει στην κύρια ταυτότητα. Εκτός αν είστε διαχειριστής πλατφόρμας, μία από τις δύο πρέπει να μην έχει σύνδεση και η ταυτότητα με σύνδεση γίνεται η κύρια — ο διακομιστής το ελέγχει αυτό, ό,τι κι αν επιλεγεί εδώ.',
    candidatesLabel: 'τα άτομα που διαχειρίζεστε',
    needTwo: 'Χρειάζεστε τουλάχιστον δύο άτομα στο πεδίο εφαρμογής σας για να συνδέσετε.',
    aliasLabel: 'Ψευδώνυμο (αυτή η ταυτότητα γίνεται ο δείκτης)',
    primaryLabel: 'Κύρια (η ταυτότητα που παραμένει)',
    choose: 'Επιλέξτε…',
    hasLogin: '(έχει σύνδεση)',
    noLogin: '(χωρίς σύνδεση)',
    link: 'Σύνδεση',
    cancel: 'Ακύρωση',
  },
  erase: {
    completedTitle: 'Η διαγραφή ολοκληρώθηκε',
    completedText:
      'Η ταυτότητα διαγράφηκε. Το αρχείο ελέγχου είναι ψευδωνυμοποιημένο, όχι διαγραμμένο· οι συνδεδεμένες ταυτότητες παραμένουν με τον δείκτη τους επαναφερμένο.',
    departmentsWithoutAdmin: 'Τμήματα που μένουν χωρίς διαχειριστή: {{names}}',
    measurementsNotDeleted:
      'Οι μετρήσεις στην υπηρεσία λήψης δεδομένων ΔΕΝ διαγράφηκαν — αυτή η δυνατότητα δεν υπάρχει ακόμη εκεί. Παρακολουθήστε το εκτός του πίνακα ελέγχου.',
    backToUsers: 'Επιστροφή στους χρήστες',
    title: 'Διαγραφή αυτού του ατόμου',
    lead: 'Αυτό διαγράφει οριστικά και μη αναστρέψιμα την ταυτότητα {{userId}}: την εγγραφή χρήστη, τις συμμετοχές, τις συγκαταθέσεις και τις εκχωρήσεις της. Οι συνδεδεμένες ταυτότητες παραμένουν· τα δεδομένα από το Gengee παραμένουν· το αρχείο ελέγχου είναι ψευδωνυμοποιημένο. Πληκτρολογήστε {{confirmWord}} για επιβεβαίωση.',
    confirmWord: 'ΔΙΑΓΡΑΦΗ',
    confirmationLabel: 'Επιβεβαίωση',
    erasePermanently: 'Οριστική διαγραφή',
    cancel: 'Ακύρωση',
  },
  requests: {
    title: 'Αιτήματα API',
    lead: 'Τα καταγεγραμμένα αιτήματα του API λήψης δεδομένων για μια πηγή, με τα πιο πρόσφατα πρώτα, προαιρετικά περιορισμένα σε ένα χρονικό παράθυρο.',
    filterSource: 'Φιλτράρισμα κατά πηγή',
    sourcePlaceholder: 'id πηγής',
    filterFrom: 'Από',
    filterTo: 'Έως',
    filter: 'Φιλτράρισμα',
    enterSourceHint: 'Εισαγάγετε ένα id πηγής για να φορτώσετε το αρχείο αιτημάτων της.',
    empty: 'Δεν έχουν καταγραφεί αιτήματα για αυτή την πηγή και το παράθυρο.',
    when: 'Πότε',
    method: 'Μέθοδος',
    path: 'Διαδρομή',
    status: 'Κατάσταση',
    rowsLabel: 'τα αιτήματα',
  },
};
